import { EventEmitter } from 'events';
import { default as RoadLoader, FurnitureFeatureCollection, LaneDividerFeatureCollection, LanePolygonsFeatureCollection, RoadFeatureCollection ,LaneAttributeFeatureCollection} from '../loaders/RoadLoader';

const roadLoader = new RoadLoader();

const read = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(JSON.parse(reader.result));
    };
    reader.onerror = e => {
      reject(e);
    };
    reader.readAsText(file);
  });
};

export default class RoadGeoJSONProcessor extends EventEmitter implements IFileProcessor {
  public process(fileList: File[]) {
    const chainFurnitureFile = fileList.find(file => file.name === 'ChainFurniture.json');
    if (!chainFurnitureFile) {
      alert('未上传ChainFurniture.json文件');
      return;
    }
    const laneDividerFile = fileList.find(file => file.name === 'HADLaneDivider.json');
    if (!laneDividerFile) {
      alert('未上传HADLaneDivider.json文件');
      return;
    }
    const roadFile = fileList.find(file => file.name === 'HADRoad.json');
    if (!roadFile) {
      alert('未上传HADRoad.json');
      return;
    }
    const lanePolygonsFile = fileList.find(file => file.name === 'HADLanePolygon.json');
    if (!lanePolygonsFile) {
      alert('HADLanePolygons.json文件');
      return;
    }
    const symbol_PGFile = fileList.find(file => file.name === 'Symbol_PG.json');
    if (!symbol_PGFile) {
      alert('Symbol_PG.json文件');
      return;
    }const laneAttributeFile = fileList.find(file => file.name === 'HADLaneAttribute.json');
    if (!laneAttributeFile) {
      alert('HADLaneAttribute.json文件');
      return;
    }

    Promise.all([
      read(roadFile) as Promise<RoadFeatureCollection>,
      read(chainFurnitureFile) as Promise<FurnitureFeatureCollection>,
      read(laneDividerFile) as Promise<LaneDividerFeatureCollection>,
      read(lanePolygonsFile) as Promise<LanePolygonsFeatureCollection>,
      read(symbol_PGFile) as Promise<LanePolygonsFeatureCollection>,
      read(laneAttributeFile) as Promise<LaneAttributeFeatureCollection>,
    ]).then(result => {
      const isName = result[0].features.every((item: any) => !!item.properties.NAME);
      if (!isName) {
        return alert('缺少车道名称(NAME)');
      }
      const isFeiJiDongC = result[3].features.every((item: any) => typeof item.properties.FeiJiDongC === 'number' );
      if (!isFeiJiDongC) {
        return alert('缺少非机动车道类型(FeiJiDongC)');
      }
      roadLoader.setData(result[0], result[1], result[2], result[3],result[4],result[5]);
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/processors/RoadGeoJSONProcessor.ts